import { http } from '@/core/helpers/http.helper';
import { TargetGroupFilter } from '../../target-group-filters/target-group-filter.interface';

export class TargetGroupFilterService {
   async getTargetGroupFilters(clusterId: number) {
      const response = await http.get(`/clusters/${clusterId}/target-group-filters`);
      return response.data;
   }

   async getTargetGroupFilter() {
      throw Error('Method not implemented');
   }

   async postTargetGroupFilters(clusterId: number, targetGroupFilters: Array<TargetGroupFilter>) {
      const response = await http.post(`/clusters/${clusterId}/target-group-filters`, targetGroupFilters);
      return response.data;
   }

   async putTargetGroupFilter() {
      throw Error('Method not implemented');
   }

   async deleteTargetGroupFilterTeams(clusterId: number) {
      const response = await http.delete(`/clusters/${clusterId}/teams/target-group-filters`);
      return response.data;
   }
}
